export const FEATURES = [
  {
    title: 'Sales dashboard',
    text:
      'Track the sales metrics of your brand, find out how many items have been shipped out to your customers, check day-to-day views of your products as well as posts that feature them. All the relevant data presented in a concise, clear, and easy to read way.',
    image: 'magic/products/magic1.jpg',
    href: '/sellwithflip',
    id: 'sales-dashboard',
    previewText:
      'Track the sales metrics of your brand, find out how many items have been shipped out to your customers, etc. All the relevant data presented in a concise, clear, and easy to read way.',
  },
  {
    title: 'Inventory & PO management',
    text:
      'Review your inventory health, manage stock-outs effectively, and keep an eye on the quantity of stock as well as the ordered products.',
    image: 'magic/products/magic2.jpg',
    href: '/sellwithflip',
    id: 'inventory-management',
  },
  {
    title: 'Content analysis & tracking',
    text:
      'Track the performance of all the content on Flip related to your brand. Know which of your products are popular and which ones are talked about the most.',
    image: 'magic/products/magic3.jpg',
    href: '/sellwithflip',
    id: 'analytics-tracking',
  },
  {
    title: 'Gratis item management',
    text:
      "Target specific users to test new products and be aware of their retention. Track the generated content as well as repeat buyers who come back because of the gratis items you've sent them.",
    image: 'magic/products/magic4.jpg',
    href: '/sellwithflip',
    id: 'gratis-management',
  },
  {
    title: 'Orders, items, & payments',
    text:
      'Manage your product listings and track your transfers and revenue. All in one dashboard.',
    image: 'magic/products/magic5.jpg',
    href: '/sellwithflip',
    id: 'orders',
  },
  {
    title: 'Ads performance management',
    text:
      'Scale your brand through our self-serve ads management tools. Remove all the guess work when it comes to performance advertising.',
    image: 'magic/products/magic6.jpg',
    href: '/sellwithflip',
    id: 'performance',
  },
]
